import React from 'react';
import logo from '../assets/ReansConsultingLogo.png';
import Navbar from './Navbar';

export default function Header() {
  return (
    <header className="sticky-top bg-white shadow-sm px-3 px-md-5 d-flex justify-content-between align-items-center">
      <img src={logo} alt="Reans Consulting Logo" height="60" />
      <Navbar />
    </header>
  );
}
